export class Stage {
  stageId
  pipelineStageId
  groupId
  order
  visible
  name
  hasActiveUploadWorkflow

  constructor(stage = {}) {
    this.stageId = stage.stageId ? String(stage.stageId) : ''
    this.pipelineStageId = stage.pipelineStageId ? String(stage.pipelineStageId) : ''
    this.groupId = stage.groupId ? String(stage.groupId) : ''
    this.order = stage.order ? Number(stage.order) : 0
    this.visible = stage.visible ? Boolean(stage.visible) : false
    this.name = stage.name ? String(stage.name) : ''
    this.hasActiveUploadWorkflow = Boolean(stage.hasActiveUploadWorkflow)
  }
}